import { Card, Space } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import SecondaryProgramDataTable from '../../../components/datatables/secondary/SecondaryProgramsDataTable';
import Breadcrumbs from '../../../config/Breadcrumbs';
import InstitutionDTO from '../../../models/InstitutionDTO';
import UserSecurity from '../../../models/UserSecurity';
import HeaderPortal from '../../../portals/HeaderPortal';
import { StateStoreModel } from '../../../redux/state/StateStoreModel';
import HistoryUtil from '../../../utils/HistoryUtil';
import ParameterUtil from '../../../utils/ParameterUtil';

interface AcademicYearSecondaryProgramConfigurationPageState {
  loading: boolean;
  academicYear: number;
}

interface AcademicYearSecondaryProgramConfigurationPageProps {
  currentUser: UserSecurity | null;
  selectedInstitution: InstitutionDTO | null;
}

class AcademicYearSecondaryProgramConfigurationPage extends React.Component<AcademicYearSecondaryProgramConfigurationPageProps & RouteComponentProps<RouteObject>, AcademicYearSecondaryProgramConfigurationPageState> {

  constructor(props: AcademicYearSecondaryProgramConfigurationPageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      loading: false,
      academicYear: 0,
    };
  }

  componentDidMount() {
    const id = Number.parseInt(ParameterUtil.getPathPart(this.props.match, 'academicYearId'));

    this.setState({ academicYear: id });
  }

  private onBack = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content >
        <HeaderPortal title='Programs' breadcrumbs={Breadcrumbs.academicYearSecondaryProgramsConfigurationList(this.state.academicYear)}
          onBack={this.onBack} />
        < Space direction="vertical" size="large">
          <Card title="Programs">
            <Space direction='vertical' size="large">
              <SecondaryProgramDataTable
                academicYear={this.state.academicYear}
                configuration={true} />
            </Space>
          </Card>
        </Space>
      </Content>
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
    selectedInstitution: state.Institution.Selected
  };
}

export default withRouter(connect(mapStateToProps)(AcademicYearSecondaryProgramConfigurationPage));
